import { art } from "../sprites";
import { Sprite } from "./Sprite";
import css from "./primitives.module.css";

type TierBadgeProps = {
  /** From the creator record's Patreon tier list - never a literal (§11.4, D-1). */
  name: string;
};

/**
 * §8: "Tier is shown as a pixel item badge (cassette sprite) plus the tier name
 * in gold mono - never a text-only pill."
 */
export function TierBadge({ name }: TierBadgeProps) {
  return (
    <span className={css.tierBadge}>
      {/* §10: the tier badge is one of the two sprites that carry a name. */}
      <Sprite src={art.cassette} size={26} label={`${name} tier`} />
      <span className={css.tierName}>{name}</span>
    </span>
  );
}
